import React, {useEffect, useState} from 'react';

interface Props {
    defaultMinutes?: number;
}

const DiscussionTimer: React.FC<Props> = ({defaultMinutes = 8}) => {
    const [totalSeconds, setTotalSeconds] = useState(defaultMinutes * 60);
    const [secondsLeft, setSecondsLeft] = useState(defaultMinutes * 60);
    const [running, setRunning] = useState(false);

    useEffect(() => {
        if (!running || secondsLeft <= 0) return;
        const timeout = setTimeout(() => setSecondsLeft(s => s - 1), 1000);
        return () => clearTimeout(timeout);
    }, [running, secondsLeft]);

    useEffect(() => {
        if (secondsLeft === 0) setRunning(false);
    }, [secondsLeft]);

    const mm = Math.floor(secondsLeft / 60).toString().padStart(2, '0');
    const ss = (secondsLeft % 60).toString().padStart(2, '0');

    const adjust = (deltaMinutes: number) => {
        const next = Math.max(60, totalSeconds + deltaMinutes * 60);
        setTotalSeconds(next);
        setSecondsLeft(next);
        setRunning(false);
    };

    return (
        <div className="GmTimer">
            <div className={`GmTimer-clock ${secondsLeft === 0 ? 'GmTimer-clock--done' : ''}`}>{mm}:{ss}</div>
            <div className="GmTimer-row">
                <button className="GmBtn GmBtn--small" onClick={() => adjust(-1)}>−1 мин</button>
                <button className="GmBtn GmBtn--small" onClick={() => adjust(1)}>+1 мин</button>
            </div>
            <div className="GmTimer-row">
                <button className="GmBtn" onClick={() => setRunning(r => !r)}>{running ? 'Пауза' : 'Старт'}</button>
                <button className="GmBtn" onClick={() => {
                    setSecondsLeft(totalSeconds);
                    setRunning(false);
                }}>Сброс
                </button>
            </div>
        </div>
    );
};

export default DiscussionTimer;
